import OnlineUsers from "../onlineUsers/OnlineUsers";
import { AuthContext } from "../../../context/AuthContex";
import { useContext } from "react";
import { useEffect, useState } from "react";
import axios from "axios";
import Usersonline from "../users/Usersonline";
import { Link } from "react-router-dom";
import Minichart from "../tradingview/Minichart";
import { MarketOverview } from "react-tradingview-embed";

export default function Rightbar() {
  const [amigos, setAmigos] = useState([]);
  const { user } = useContext(AuthContext);
  const PF = process.env.REACT_APP_PUBLIC_FOLDER;

  useEffect(() => {
    const buscarAmigos = async () => {
      try {
        const res = await axios.get("usuarios/todos");
        setAmigos(res.data);
      } catch (err) {
        console.log(err);
      }
    };
    buscarAmigos();
  }, [user._id]);
  return (
    <>
      <div className="col-xxl-3 col-lg-3 col-md-6 scroll">
        <Minichart />
        <br />
        <MarketOverview />
      </div>
    </>
  );
}
